import React, { Component } from "react";
import { Form, Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { get } from "lodash";
import IconTime from "../../assets/icon-time.svg";
import MOMDesc from "../MOM/MOMDesc";
import {
  getColor,
  isValidArray,
  transformProjectCategoryId
} from "../../helper";
import { dayAgo, formatNumber } from "../../helper";
import { PATHS, ISSUE_STATUS } from "../../constant";
//import { Pli } from "../pliReview";
import { Pli } from "./selectProject/monitoringFlags/PliReview";
import { DisplayContent } from "../displayContent";
//import { Pragati } from "../prgatiReview";
import { Pragati } from "./selectProject/monitoringFlags/PragatiReview";
//import { Nip } from "../nipReview";
import { Nip } from "./selectProject/monitoringFlags/NipReview";
import {
  MultipleTags,
  OrganizationTemplate,
  ReadMore,
  RedirectUser
} from "../reusableComponent";
//import { PmFoundationStone } from "../pmFoundationStone/pmFoundationStone";
import { PmFoundationStone } from "./selectProject/monitoringFlags/PmFoundationStone";
import { CmPragatiYatra } from "./selectProject/monitoringFlags/cmPragatiYatra";
import { CmFoundationStone } from "./selectProject/monitoringFlags/cmFoundationStone";
//import { PmGatiShakti } from "../pmGatiShakti/pmGatiShakti";
//import { PmGatiShakti } from "./selectProject/monitoringFlags/PmGatishakti";
import { PmGatiShakti } from "./selectProject/monitoringFlags/PmGatishaktiCreate.js";
import { PmgsHipimage } from "./selectProject/monitoringFlags/pmgshipCreate.js";
//import { March24 } from "../march24";
import { March24 } from "./selectProject/monitoringFlags/March24";
import { EscalationLevelModal } from "../reusableComponent/EscalationLevel/EscalationLevelModal";
import IssuePragatiReview from "../prgatiReview/IssuePragatiReview";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toolttipDisplayMessage } from "../issueList/helper";
import { ReadMoreContent } from "../reusableComponent/readMore/readMoreContent.js";
import DisplayByPermission from "../../component/DisplayByPermission";
import PariveshData from "../pariveshData";
import { PragatiPipeline } from "./selectProject/monitoringFlags/PragatiPipeline.js";
import IssuePipelineReview from "../prgatiReview/IssuePipelineReview.js";
export class SelectIssueSingle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOtherPPList: false,
      isPariveshModalVisible: false,
      selectedIssueSubCategoryId: null,
      selectedProposalNoParivesh: null
    };
  }

  selectionHandler = () => {
    const {
      idx,
      selectionHandler,
      fromCreateAgendaPage,
      deleteHandler
    } = this.props;
    fromCreateAgendaPage ? deleteHandler(idx) : selectionHandler(idx);
  };

  toggleOtherPPList = () => {
    this.setState({
      showOtherPPList: !this.state.showOtherPPList
    });
  };

  showPraiveshModal = () => {
    //const { issueData } = this.state;
    const { issue } = this.props;
    console.log(issue);
    //let data = get(issueData, "data", null);
    const issueSubcategoryId = get(issue, "subCategoryId", null);
    const proposalNoParivesh = get(issue, "proposalNoParivesh", null);
    this.setState({
      isPariveshModalVisible: true,
      selectedIssueSubCategoryId: issueSubcategoryId,
      selectedProposalNoParivesh: proposalNoParivesh
    });
  };
  closePariveshModal = () => {
    this.setState({
      isPariveshModalVisible: false
    });
  };

  render() {
    const { IssueSelected, issue } = this.props;
    const { showOtherPPList, isPariveshModalVisible } = this.state;
    const isPragatiReview = get(issue, "issuePragatiReview");
    const isPragatiPipeline = get(issue, "issuePragatiPipeLine");
    console.log(get(issue, "id"), get(issue, "issuePragatiPipeLine"));
    let content;
    if (IssueSelected === "delete") {
      content = (
        <div
          className="delete-issue"
          title="Delete"
          onClick={this.selectionHandler}
        />
      );
    } else if (IssueSelected === "checkbox") {
      content = (
        <Form.Group controlId={`checkbox-${this.props.idx}`}>
          <Form.Check
            className={`form-checkbox ${issue.isSelected ? "checked" : ""}`}
          >
            <Form.Check.Input
              type="checkbox"
              name="select-issue"
              value={issue.isSelected}
            />
            <Form.Check.Label onClick={this.selectionHandler} />
          </Form.Check>
        </Form.Group>
      );
    } else {
      content = "";
    }

    const createdBy =
      issue.project &&
      issue.project.projectPPList &&
      issue.project.projectPPList.length
        ? issue.project.projectPPList[0]
        : null;
    const projectPPList =
      issue.project &&
      issue.project.projectPPList &&
      issue.project.projectPPList.length
        ? issue.project.projectPPList
        : [];
    function getUniqueOrganizations(data) {
      // Filter out null values before creating the set
      const filteredData = data.filter(item => item.organizationGroup !== null);
      // Create a Set to store unique organization groups
      const uniqueOrgs = new Set(
        filteredData.map(item => item.organizationGroup)
      );
      // Convert the Set back to an array
      return Array.from(uniqueOrgs);
    }
    const uniqueOrganizations = getUniqueOrganizations(projectPPList);
    const projectCost = formatNumber(
      get(issue, "project.revisedCost", 0) ||
        get(issue, "project.totalCost", "0")
    );
    console.log("issue105105105", get(issue, "project.pmGatiShaktiNew"));
    return (
      <React.Fragment>
        <div className="select-issue-wrapper agenda-issue-wrapper">
          <Form className="select-issue-form">{content}</Form>
          <div className="issue-container">
            <div className="select-issue-headers">
              <div className="select-issue-number">
                Project{" "}
                <b>
                  {" "}
                  <Link
                    to={{
                      pathname: PATHS.PROJECT_DETAILS,
                      search: `?projectId=${get(issue, "project.id")}`
                    }}
                  >
                    #{get(issue, "project.displayId", "NA")}
                  </Link>
                </b>
              </div>
              <div id="agenda-organisation">
                {uniqueOrganizations.map((organization, index) => (
                  <OrganizationTemplate
                    key={index}
                    title={organization}
                    classes="organisation-name"
                  />
                ))}
                {/* {projectPPList &&
                  projectPPList.map(item => {
                    if (item.organizationGroup) {
                      return (
                        <OrganizationTemplate
                          title={item.organizationGroup}
                          classes="organisation-name"
                        />
                      );
                    }
                  })} */}
              </div>

              <div className="select-issue-single-tags">
                <MultipleTags
                  containerClass="select-issue-single-stages"
                  options={[
                    {
                      title: get(
                        issue,
                        "project.projectStatusWithRespectToIssueStatus"
                      ),
                      classes: getColor(
                        get(
                          issue,
                          "project.projectStatusWithRespectToIssueStatus"
                        )
                      )
                    },
                    {
                      title:
                        get(issue, "project.projectCompletionDTO.status") !==
                        "NO IMPLEMENTATION"
                          ? get(issue, "project.projectCompletionDTO.status") ||
                            get(issue, "project.projectCompletionStage")
                          : "",
                      classes:
                        get(issue, "project.projectCompletionDTO.status") !==
                        "NO IMPLEMENTATION"
                          ? getColor(
                              get(
                                issue,
                                "project.projectCompletionDTO.status"
                              ) || get(issue, "project.projectCompletionStage")
                            )
                          : ""
                    }
                  ]}
                />
              </div>
              <div
                className={`select-issue-title 
              ${
                /[\u0900-\u097F]/.test(get(issue, "project.name"))
                  ? "hindi-text-wrap"
                  : ""
              }`}
              >
                {get(issue, "project.name", "NA")}
              </div>
              <div className="select-issue-sponsoring">
                <label>
                  Sponsoring{" "}
                  {transformProjectCategoryId(
                    get(issue, "project.sponsoringMinistry", null) ||
                      get(issue, "project.sponsoredByCategory")
                  )}{" "}
                </label>
                <span>{get(issue, "project.sponsoredBy", "NA")}</span>
              </div>
              {get(issue, "project.sponsoringDepartment") ? (
                <div className="select-issue-sponsoring">
                  <label>Sponsoring Department</label>
                  <span>
                    {get(issue, "project.sponsoringDepartment.name", null)}
                  </span>
                </div>
              ) : null}
              <Pragati
                className={"pragati-review select-issue"}
                isValidProject={get(issue, "project.pragatiReview")}
              />
              {/* <PragatiPipeline
                className={'pragati-review select-issue'}
                isValidProject={get(issue, 'project.pragatiPipeline')}
              /> */}
              <PragatiPipeline
                className={"pragati-review select-issue"}
                isValidProject={
                  !get(issue, "project.pragatiReview") &&
                  get(issue, "project.pragatiPipeline")
                }
              />
              <Nip
                className={"pragati-review select-issue"}
                isValidProject={get(issue, "project.nipReview")}
              />
              <PmFoundationStone
                className={"pragati-review select-issue"}
                isValidProject={get(issue, "project.pmFoundationStone")}
              />
              <CmPragatiYatra
                className={"pragati-review select-issue"}
                isValidProject={get(issue, "project.cmPragatiYatra")}
              />
              <CmFoundationStone
                className={"pragati-review select-issue"}
                isValidProject={get(issue, "project.cmFoundationStone")}
              />
              <PmGatiShakti
                className={"pragati-review select-issue"}
                isValidProject={get(issue, "project.pmGatiShaktiNew")}
              />
              <PmgsHipimage
                className={"pragati-review select-issue"}
                isValidProject={get(issue, "project.pmgsHip")}
              />
              <Pli
                className={"pragati-review select-issue"}
                isValidProject={get(issue, "project.pli")}
              />
              <March24
                className={"pragati-review select-issue"}
                isValidProject={get(issue, "project.march24")}
              />
              <div className="select-issue-cost">
                <label>Project Cost</label>
                <span>
                  {parseFloat(projectCost) !== 0
                    ? `₹ ${projectCost} Cr.`
                    : "N/A"}
                </span>
              </div>
              {projectPPList && projectPPList.length ? (
                <div className="project-created-by">
                  <label>Project Proponent</label>
                  <span className="first-pp-name">
                    <RedirectUser
                      isIssueForwarded={true}
                      title={get(createdBy, "name", null)}
                      id={get(createdBy, "id", null)}
                    />
                  </span>
                  {projectPPList && projectPPList.length > 1 ? (
                    <div
                      className={`dropdown field-sort ${
                        showOtherPPList ? "visible" : ""
                      }`}
                      onClick={this.toggleOtherPPList}
                    >
                      <div
                        className={`dropdown-overlay ${
                          showOtherPPList ? "visible" : ""
                        }`}
                      />
                      <div className="dropdown-selected-value">
                        + {projectPPList.length - 1}
                      </div>
                      <div className="dropdown-option-list hidden-mobile">
                        <div className="dropdown-option-list-heading" />
                        {projectPPList
                          ? projectPPList.map((value, index) => {
                              if (index !== 0) {
                                return (
                                  <RedirectUser
                                    isProjectProponentDetail={true}
                                    title={get(value, "name", null)}
                                    id={get(value, "id", null)}
                                  />
                                );
                              }
                            })
                          : null}
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>
            <div className="select-issue-content">
              <div className="issue-list-top">
                <div className="issue-list-header">
                  <span
                    className={`issue-number ${
                      get(issue, "duplicate") ? "duplicate-issue-number" : ""
                    }`}
                  >
                    {get(issue, "duplicate") ? "Duplicate Issue" : "Issue"}{" "}
                    <b>
                      <Link
                        to={{
                          pathname: PATHS.ISSUE_DETAIL,
                          search: `?issueId=${get(
                            issue,
                            "id"
                          )}&&projectId=${get(issue, "project.id")}`
                        }}
                      >
                        #{get(issue, "project.displayId", "NA")}/
                        {get(issue, "id", "NA")}
                      </Link>
                    </b>
                  </span>
                  {/**CR 289 Changes Starts-Yajnadutta */}
                  {get(issue, "escalationLevelName", "NA") == null ? null : (
                    <EscalationLevelModal
                      IssueId={get(issue, "id")}
                      EscalationName={get(issue, "escalationLevelName", "NA")}
                      pragatiDetailPage={true}
                      pragatiDetailPageCss={true}
                    />
                  )}
                  {/**CR 289 Changes End-Yajnadutta */}
                  <h2
                    className={`issue-title ${
                      get(issue, "title").match(/[\u0900-\u097F]/)
                        ? "hindi-text-wrap-comment"
                        : ""
                    }`}
                  >
                    {get(issue, "title", "NA")}
                  </h2>
                </div>
                <div className="issue-list-status">
                  <div className="issue-list-status-inner">
                    <div className="issue-assignee">
                      <b className="animated fadeInRight">
                        {get(issue, "status") === ISSUE_STATUS.REJECT ||
                        get(issue, "status") === ISSUE_STATUS.RESOLVED ||
                        get(issue, "status") === ISSUE_STATUS.REJECTED ||
                        get(issue, "status") === ISSUE_STATUS.HOLD ||
                        get(issue, "status") === ISSUE_STATUS.reject ||
                        get(issue, "status") === ISSUE_STATUS.resolved ||
                        get(issue, "status") === ISSUE_STATUS.hold ||
                        get(issue, "status") === ISSUE_STATUS["On Hold"] ? (
                          get(issue, "status") === ISSUE_STATUS.REJECT ||
                          get(issue, "status") === ISSUE_STATUS.reject ||
                          get(issue, "status") === ISSUE_STATUS.REJECTED ? (
                            <>
                              <span className="issue-assignee-title">
                                Rejected by{" "}
                              </span>
                              <b>{get(issue, "issueStatusChangeGroup")}</b>
                            </>
                          ) : get(issue, "status") === ISSUE_STATUS.RESOLVED ||
                            get(issue, "status") === ISSUE_STATUS.resolved ? (
                            <>
                              <span className="issue-assignee-title">
                                Resolved by{" "}
                              </span>
                              <b>{get(issue, "issueStatusChangeGroup")}</b>
                            </>
                          ) : (
                            <>
                              <span className="issue-assignee-title">
                                Hold by{" "}
                              </span>
                              <b> {get(issue, "issueStatusChangeGroup")}</b>
                            </>
                          )
                        ) : (
                          <>
                            <span className="issue-assignee-title">
                              Assigned to{" "}
                            </span>
                            <b>{get(issue, "assigneeGroup")}</b>
                          </>
                        )}
                      </b>
                    </div>
                    <div className="issue-assign-date">
                      <Image src={IconTime} alt="Time" />
                      <span>
                        {dayAgo(
                          get(issue, "createdDate") ||
                            get(issue, "lastAssigneeDate")
                        )}
                      </span>
                    </div>
                  </div>
                  <OverlayTrigger
                    defaultShow={false}
                    trigger="hover"
                    placement="top"
                    overlay={
                      <Tooltip className="issues-status-tooltip ">
                        {toolttipDisplayMessage(get(issue, "status", "NA"))}
                      </Tooltip>
                    }
                  >
                    <div>
                      <Button
                        className={`btn-extra-small animated flipInX ${getColor(
                          get(issue, "status", "NA").toLowerCase()
                        )} unClickable`}
                        style={{
                          textTransform: "uppercase",
                          borderRadius: "15px"
                        }}
                      >
                        {get(issue, "status", "NA")}
                      </Button>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="issue-list-middle">
                <div className="issue-list-desc-wrapper">
                  <span className="issue-recipient">
                    <span className="issue-recipient-title">
                      Recipient{" "}
                      {transformProjectCategoryId(
                        get(issue, "recipientGroupCategory")
                      )}{" "}
                      -{" "}
                    </span>
                    {get(issue, "recipientGroup", "NA")}
                  </span>
                  {get(issue, "districtName") ? (
                    <span className="issue-recipient">
                      <span className="issue-recipient-title">
                        {get(issue, "recipientLabel")} -
                      </span>{" "}
                      {get(issue, "districtName", "NA")}
                    </span>
                  ) : null}
                  {get(issue, "secondaryMinistry") ||
                  get(issue, "secondaryRecipientGroupName") ? (
                    <span className="issue-recipient">
                      <span className="issue-recipient-title">
                        Secondary Recipient -
                      </span>{" "}
                      {get(issue, "secondaryMinistry", "NA") ||
                        get(issue, "secondaryRecipientGroupName", "NA")}
                    </span>
                  ) : get(issue, "secondaryState") ? (
                    <span className="issue-recipient">
                      <span className="issue-recipient-title">
                        Secondary Recipient -
                      </span>{" "}
                      {get(issue, "secondaryState", "NA")}
                    </span>
                  ) : null}

                  <p className="issue-category to-n-fro">
                    <span className="slide-issue">
                      <span className="issue-category-title">
                        Issue Category -{" "}
                      </span>
                      {get(issue, "category", "NA")}
                    </span>
                    <span className="clowdy" />
                  </p>
                  {get(issue, "subCategory") ? (
                    <p className="issue-sub-category to-n-fro">
                      <span className="slide-issue">
                        <span className="issue-category-title">
                          Issue Sub-Category -{" "}
                        </span>
                        {get(issue, "subCategory", "NA")}
                      </span>
                      <span className="clowdy" />
                    </p>
                  ) : null}
                  {get(issue, "proposalNoParivesh") ? (
                    <p className="issue-sub-category to-n-fro">
                      <span className="slide-issue">
                        <span className="issue-category-title">
                          Proposal No. (PARIVESH) -{" "}
                        </span>
                        <span
                          className="proposal-link"
                          onClick={this.showPraiveshModal}
                        >
                          {get(issue, "proposalNoParivesh", "NA")}
                        </span>
                      </span>
                      <span className="clowdy" />
                    </p>
                  ) : null}
                  <div className="issue-list-desc">
                    {/* <ReadMore
                      clamp={3}
                      content={get(issue, "description", "NA")}
                    /> */}
                    <ReadMoreContent
                      clamp={3}
                      content={get(issue, "description")}
                    />
                  </div>
                  {(get(issue, "latestIssueComments") && (
                    <div style={{ paddingBottom: "15px" }}>
                      <div className="comment-heading">
                        <h3>Latest Comment</h3>
                      </div>
                      <DisplayContent
                        classes={"issue-list-desc"}
                        content={get(issue, "latestIssueComments")}
                      />
                    </div>
                  )) ||
                    null}

                  {isValidArray(get(issue, "meetingDecisionDTOS")) ? (
                    <MOMDesc
                      meeting={get(issue, "meetingDecisionDTOS[0]")}
                      count={get(issue, "meetingDecisionDTOS").length}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {/* <IssuePragatiReview
                isPragati={get(issue, "issuePragatiReview")}
                isAgendaDetail={true}
                className="select-issue-flag"
              /> */}
              {isPragatiReview ? (
                <IssuePragatiReview
                  isPragati={isPragatiReview}
                  isAgendaDetail={true}
                  className="select-issue-flag"
                />
              ) : isPragatiPipeline ? (
                <IssuePipelineReview
                  isPragatiPipeline={isPragatiPipeline}
                  isAgendaDetail={true}
                  className="select-issue-pp-flag"
                />
              ) : null}
            </div>
          </div>
        </div>
        <DisplayByPermission display={isPariveshModalVisible}>
          <PariveshData
            show={isPariveshModalVisible}
            closeModal={this.closePariveshModal}
            issueSubCategoryId={this.state.selectedIssueSubCategoryId}
            proposalNoParivesh={this.state.selectedProposalNoParivesh}
          />
        </DisplayByPermission>
      </React.Fragment>
    );
  }
}

export default SelectIssueSingle;
